import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const Locations = Loadable({
  loader: () => import('./views/Locations'),
  loading: Loading,
});

const ManageLocation = Loadable({
  loader: () => import('./views/Locations/ManageLocation'),
  loading: Loading,
});

const CreateLocation = Loadable({
  loader: () => import('./views/Locations/CreateLocation'),
  loading: Loading,
});

const Budgets = Loadable({
  loader: () => import('./views/Budgets'),
  loading: Loading,
});

const ManageBudget = Loadable({
  loader: () => import('./views/Budgets/ManageBudget'),
  loading: Loading,
});

const CreateBudget = Loadable({
  loader: () => import('./views/Budgets/CreateBudget'),
  loading: Loading,
});

const Menus = Loadable({
  loader: () => import('./views/Menus'),
  loading: Loading,
});

const MenuItems = Loadable({
  loader: () => import('./views/MenuItems'),
  loading: Loading,
});

const Orders = Loadable({
  loader: () => import('./views/Orders'),
  loading: Loading,
});

const ManageOrder = Loadable({
  loader: () => import('./views/Orders/ManageOrder/'),
  loading: Loading,
});

const CreateMenu = Loadable({
  loader: () => import('./views/Menus/CreateMenu/'),
  loading: Loading,
});

const CreateMenuItem = Loadable({
  loader: () => import('./views/MenuItems/CreateMenuItem/'),
  loading: Loading,
});
const ManageMenu = Loadable({
  loader: () => import('./views/Menus/ManageMenu/'),
  loading: Loading,
});
const ManageMenuItem = Loadable({
  loader: () => import('./views/MenuItems/ManageMenuItem/'),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Accounts = Loadable({
  loader: () => import('./views/Accounts'),
  loading: Loading,
});

const ManageAccount = Loadable({
  loader: () => import('./views/Accounts/ManageAccount'),
  loading: Loading,
});

const AuditEvents = Loadable({
  loader: () => import('./views/AuditEvents'),
  loading: Loading,
});

const Costs = Loadable({
  loader: () => import('./views/Costs'),
  loading: Loading,
});

const Production = Loadable({
  loader: () => import('./views/Production'),
  loading: Loading,
});

const MakeOrder = Loadable({
  loader: () => import('./views/MakeOrder'),
  loading: Loading,
});

const OrderAgain = Loadable({
  loader: () => import('./views/MakeOrder/OrderAgain'),
  loading: Loading,
});



// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
let routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/locations/:locationId', name: 'Manage Location', component: ManageLocation },
  { path: '/locations', exact: true, name: 'Locations', component: Locations },
  { path: '/create/location', name: 'Create Location', component: CreateLocation },
  { path: '/budgets/:code', name: 'Manage Budget', component: ManageBudget },
  { path: '/budgets', exact: true, name: 'Budgets', component: Budgets },
  { path: '/create/budget', name: 'Create Budget', component: CreateBudget },
  { path: '/menus/:menuId', name: 'Manage', component: ManageMenu },
  { path: '/menus', exact: true, name: 'Menus', component: Menus },
  { path: '/create/menu', name: 'Create Menu', component: CreateMenu },
  { path: '/menuItems/:id', name: 'Manage Items', component: ManageMenuItem },
  { path: '/menuItems', exact: true, name: 'MenuItems', component: MenuItems },
  { path: '/create/menuItem', name: 'Create Menu Item', component: CreateMenuItem },
  { path: '/orders', exact: true, name: 'Orders', component: Orders },
  { path: '/orders/:code/:datetime', name: 'Manage Order', component: ManageOrder },
  { path: '/accounts/:role/:accountId', name: 'Manage Account', component: ManageAccount },
  { path: '/accounts', exact: true, name: 'Accounts', component: Accounts},
  { path: '/audit-events', exact: true, name: 'Audit Events', component: AuditEvents},
  { path: '/costs', exact: true, name: 'Costs', component: Costs},
  { path: '/production', exact: true, name: 'Production', component: Production}
];

if (process.env.REACT_APP_USER_TYPE === 'admin'){
  routes = [
    { path: '/', exact: true, name: 'Home', component: DefaultLayout },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard },
    { path: '/locations/:locationId', name: 'Manage Location', component: ManageLocation },
    { path: '/locations', exact: true, name: 'Locations', component: Locations },
    { path: '/create/location', name: 'Create Location', component: CreateLocation },
    { path: '/budgets/:code', name: 'Manage Budget', component: ManageBudget },
    { path: '/budgets', exact: true, name: 'Budgets', component: Budgets },
    { path: '/create/budget', name: 'Create Budget', component: CreateBudget },
    { path: '/menus/:menuId', name: 'Manage', component: ManageMenu },
    { path: '/menus', exact: true, name: 'Menus', component: Menus },
    { path: '/create/menu', name: 'Create Menu', component: CreateMenu },
    { path: '/menuItems/:id', name: 'Manage Items', component: ManageMenuItem },
    { path: '/menuItems', exact: true, name: 'MenuItems', component: MenuItems },
    { path: '/create/menuItem', name: 'Create Menu Item', component: CreateMenuItem },
    { path: '/orders', exact: true, name: 'Orders', component: Orders },
    { path: '/orders/:code/:datetime', name: 'Manage Order', component: ManageOrder },
    { path: '/accounts/:role/:accountId', name: 'Manage Account', component: ManageAccount },
    { path: '/accounts', exact: true, name: 'Accounts', component: Accounts},
    { path: '/audit-events', exact: true, name: 'Audit Events', component: AuditEvents},
    { path: '/costs', exact: true, name: 'Costs', component: Costs},
    { path: '/production', exact: true, name: 'Production', component: Production}
  ];
}
else if (process.env.REACT_APP_USER_TYPE === 'caterer'){
  routes = [
    { path: '/', exact: true, name: 'Home', component: DefaultLayout },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard },
    { path: '/menus/:menuId', name: 'Manage', component: ManageMenu },
    { path: '/menus', exact: true, name: 'Menus', component: Menus },
    { path: '/create/menu', name: 'Create Menu', component: CreateMenu },
    { path: '/menuItems/:id', name: 'Manage Items', component: ManageMenuItem },
    { path: '/menuItems', exact: true, name: 'MenuItems', component: MenuItems },
    { path: '/create/menuItem', name: 'Create Menu Item', component: CreateMenuItem },
    { path: '/orders/:code/:datetime', name: 'Manage Order', component: ManageOrder },
    { path: '/orders', exact: true, name: 'Orders', component: Orders },
    { path: '/costs', exact: true, name: 'Costs', component: Costs},
    { path: '/production', exact: true, name: 'Production', component: Production}
  ];
} 
else {
  routes = [
    { path: '/', exact: true, name: 'Home', component: DefaultLayout },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard },
    { path: '/order', exact: true, name: 'Make Order', component: MakeOrder },
    { path: '/order/:code/:datetime', name: 'Order Again', component: OrderAgain },
    { path: '/orders', exact: true, name: 'Orders', component: Orders },
    { path: '/orders/:code/:datetime', name: 'Manage Order', component: ManageOrder }
  ];
}

export default routes;
